import { Injectable } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';

@Injectable({
  providedIn: 'root',
})
export class FileDownloadService {
  private readonly downloadHosts = new Map<Environment, string>([
    [Environment.DEMO, 'https://embeddings-demo.apigateway.co'],
    [Environment.PROD, 'https://embeddings-prod.apigateway.co'],
    [Environment.LOCAL, 'https://embeddings-demo.apigateway.co'], // Use demo for local development
    [Environment.TEST, 'https://embeddings-demo.apigateway.co'], // Use demo for test
  ]);

  constructor(private environmentService: EnvironmentService) {}

  /**
   * Gets a download URL for forcing file download
   * @param fileUrl The fileUrl (JWT token) from the knowledge source
   * @returns The complete download URL with download=true parameter
   */
  getDownloadLink(fileUrl: string): string {
    const environment = this.environmentService.getEnvironment();
    const baseUrl = this.downloadHosts.get(environment) || this.downloadHosts.get(Environment.DEMO);
    return `${baseUrl}/api/v1/embedding-file?id=${encodeURIComponent(fileUrl)}&download=true`;
  }

  /**
   * Gets a view URL for inline file viewing
   * @param fileUrl The fileUrl (JWT token) from the knowledge source
   * @returns The complete view URL for inline display
   */
  getViewLink(fileUrl: string): string {
    const environment = this.environmentService.getEnvironment();
    const baseUrl = this.downloadHosts.get(environment) || this.downloadHosts.get(Environment.DEMO);
    return `${baseUrl}/api/v1/embedding-file?id=${encodeURIComponent(fileUrl)}`;
  }
}
